// Shared product logos so branding stays consistent across the app.
// APP_LOGOS: square marketing art (tree, safe, coin, shield) for in-app UI.
// APP_WORDMARKS: horizontal text wordmark banners shown beneath the square icon.
//   benefits (SEBAA) is a standalone vertical banner with no square picture.
// APP_ICONS: opaque, store-ready 1024x1024 icons (safe margins) for store submission downloads.
export const APP_LOGOS = {
  family_tree: "/solutions/family_tree.png",
  holdings: "/solutions/holdings.png",
  currency: "/solutions/currency.png",
  benefits: "/solutions/benefits.png",
};

export const APP_WORDMARKS = {
  family_tree: "/solutions/wordmarks/family_tree.png",
  holdings: "/solutions/wordmarks/holdings.png",
  currency: "/solutions/wordmarks/currency.png",
  benefits: "/solutions/wordmarks/benefits.png",
};

export const APP_ICONS = {
  family_tree: "/solutions/icons/family_tree.png",
  holdings: "/solutions/icons/holdings.png",
  currency: "/solutions/icons/currency.png",
  benefits: "/solutions/icons/benefits.png",
};

export const appLogo = (key) => APP_LOGOS[key] || "/brand-logo.png";
export const appWordmark = (key) => APP_WORDMARKS[key] || null;
export const appIcon = (key) => APP_ICONS[key] || null;
